import { memoizeFunction } from "@fluentui/react/lib/Utilities";

import { ActionControlSize } from "@1js/acui-common";
import type { AppGalleryStyles } from "@1js/acui-gallery";
import { concatAppGalleryStyles } from "@1js/acui-gallery";

import {
  getLargePreviewGalleryStyles,
  getLargePreviewGalleryStylesStacked,
} from "./largePreviewGalleryStyles";

export const getIconGallerySizedStyles = memoizeFunction(
  (
    size: ActionControlSize | undefined,
    externalStyles: Partial<AppGalleryStyles> | undefined,
    previewStacked: boolean
  ): Partial<AppGalleryStyles> => {
    switch (size) {
      case ActionControlSize.Large:
        return concatAppGalleryStyles(
          externalStyles,
          getLargePreviewGalleryStyles(),
          previewStacked && getLargePreviewGalleryStylesStacked()
        );
      default:
        return externalStyles || {};
    }
  }
);
